
import { useState } from 'react';
import Header from '../../components/feature/Header';
import SEO from '../../components/feature/SEO';
import Footer from '../../components/feature/Footer';

interface GalleryItem {
  id: number;
  title: string;
  artist: string;
  category: string;
  image: string;
  description: string;
  size: string;
  duration: string;
  location: string;
}

const galleryItems: GalleryItem[] = [
  {
    id: 1,
    title: 'Rosa Fine Line',
    artist: 'Paz',
    category: 'Fine Line',
    image: '/images/gallery-001.jpg',
    description: 'Diseño minimalista de rosa con líneas finas y delicadas, perfecto para expresar elegancia y feminidad.',
    size: 'Pequeño (5cm)',
    duration: '1.5 horas',
    location: 'Muñeca'
  },
  {
    id: 2,
    title: 'Mandala Black Work',
    artist: 'Naz',
    category: 'Black Work',
    image: '/images/gallery-002.jpg',
    description: 'Mandala en black work con patrones geométricos complejos y tinta negra sólida.',
    size: 'Mediano (12cm)',
    duration: '3 horas',
    location: 'Antebrazo'
  },
  {
    id: 3,
    title: 'Explosión Floral',
    artist: 'Fanny',
    category: 'Color',
    image: '/images/gallery-003.jpg',
    description: 'Explosión de flores en colores vibrantes con técnica de degradados artísticos.',
    size: 'Mediano (10cm)',
    duration: '2.5 horas',
    location: 'Hombro'
  },
  {
    id: 4,
    title: 'Mariposa Acuarela',
    artist: 'Fanny',
    category: 'Color',
    image: '/images/gallery-004.jpg',
    description: 'Mariposa en técnica de acuarela con explosión de colores y efectos artísticos.',
    size: 'Mediano (8cm)',
    duration: '2.5 horas',
    location: 'Espalda'
  },
  {
    id: 5,
    title: 'Constelación Minimalista',
    artist: 'Paz',
    category: 'Fine Line',
    image: '/images/gallery-005.jpg',
    description: 'Diseño celestial minimalista con constelación en fine line personalizada.',
    size: 'Pequeño (6cm)',
    duration: '1.5 horas',
    location: 'Tobillo'
  },
  {
    id: 6,
    title: 'Serpiente Black Work',
    artist: 'Naz',
    category: 'Black Work',
    image: '/images/gallery-006.jpg',
    description: 'Serpiente en black work con diseño dramático y líneas fuertes en tinta negra.',
    size: 'Grande (18cm)',
    duration: '4 horas',
    location: 'Muslo'
  },
  {
    id: 7,
    title: 'Jardín de Colores',
    artist: 'Fanny',
    category: 'Color',
    image: '/images/gallery-007.jpg',
    description: 'Jardín de flores con explosión de colores vibrantes y técnica artística única.',
    size: 'Mediano (15cm)',
    duration: '3 horas',
    location: 'Brazo'
  },
  {
    id: 8,
    title: 'Líneas Geométricas',
    artist: 'Paz',
    category: 'Fine Line',
    image: '/images/gallery-008.jpg',
    description: 'Diseño geométrico en fine line con patrones elegantes y líneas delicadas.',
    size: 'Mediano (12cm)',
    duration: '2 horas',
    location: 'Costillas'
  },
  {
    id: 9,
    title: 'Lobo Black Work',
    artist: 'Naz',
    category: 'Black Work',
    image: '/images/gallery-009.jpg',
    description: 'Lobo en black work con diseño dramático y contrastes fuertes en tinta negra.',
    size: 'Mediano (10cm)',
    duration: '3 horas',
    location: 'Pecho'
  },
  {
    id: 10,
    title: 'Ave del Paraíso',
    artist: 'Fanny',
    category: 'Color',
    image: '/images/gallery-010.jpg',
    description: 'Flor ave del paraíso con explosión de colores tropicales vibrantes.',
    size: 'Mediano (14cm)',
    duration: '3.5 horas',
    location: 'Pierna'
  },
  {
    id: 11,
    title: 'Flor Minimalista',
    artist: 'Paz',
    category: 'Fine Line',
    image: '/images/gallery-011.jpg',
    description: 'Flor minimalista en fine line con pétalos delicados y líneas elegantes.',
    size: 'Pequeño (8cm)',
    duration: '1.5 horas',
    location: 'Cuello'
  },
  {
    id: 12,
    title: 'Cráneo Artístico',
    artist: 'Naz',
    category: 'Black Work',
    image: '/images/gallery-012.jpg',
    description: 'Cráneo artístico en black work con estilo gótico y contrastes dramáticos.',
    size: 'Grande (16cm)',
    duration: '4 horas',
    location: 'Antebrazo'
  }
];

export default function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [selectedItem, setSelectedItem] = useState<GalleryItem | null>(null);

  const categories = ['Todos', 'Fine Line', 'Black Work', 'Color'];

  const filteredItems = selectedCategory === 'Todos' 
    ? galleryItems 
    : galleryItems.filter(item => item.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <SEO
        title="Galería — Rebel Rabbit"
        description="Explora diseños delicados en fine line, black work y color creados por nuestras artistas."
        keywords="galería tatuajes, fine line, black work, color"
        ogTitle="Galería Rebel Rabbit"
        ogDescription="Colección de tatuajes delicados y artísticos"
        ogImage="/images/og.svg"
        twitterTitle="Galería Rebel Rabbit"
        twitterDescription="Nuestros trabajos destacados en Providencia"
      />
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="container mx-auto px-6">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Nuestra <span className="text-pink-500">Galería</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Explora nuestra colección de <strong>tatuajes únicos</strong> creados por nuestras 
              <strong> talentosas artistas</strong>. Cada diseño cuenta una historia especial.
            </p>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-pink-500 text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-pink-50 border border-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                onClick={() => setSelectedItem(item)}
                className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                    <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                    <p className="text-pink-300 text-sm">Por {item.artist}</p>
                    <div className="mt-3 flex items-center text-sm">
                      <i className="ri-time-line mr-2"></i>
                      <span>{item.duration}</span>
                      <span className="mx-2">•</span>
                      <span>{item.size}</span>
                    </div>
                  </div>
                </div>

                <div className="absolute top-4 right-4 bg-pink-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  {item.category}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* Modal */}
      {selectedItem && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedItem(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Image */}
              <div className="relative aspect-[3/4] lg:aspect-auto">
                <img
                  src={selectedItem.image}
                  alt={selectedItem.title}
                  className="w-full h-full object-cover object-top"
                />
                <button
                  onClick={() => setSelectedItem(null)}
                  className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl text-gray-900"></i>
                </button>
              </div>

              {/* Details */}
              <div className="p-8">
                <div className="mb-6">
                  <span className="inline-block bg-pink-100 text-pink-600 px-4 py-1 rounded-full text-sm font-semibold mb-4">
                    {selectedItem.category}
                  </span>
                  <h2 className="text-3xl font-bold text-gray-900 mb-2">
                    {selectedItem.title}
                  </h2>
                  <p className="text-pink-500 font-semibold text-lg">
                    Por {selectedItem.artist}
                  </p>
                </div>

                <p className="text-gray-600 leading-relaxed mb-8">
                  {selectedItem.description}
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-center text-gray-700">
                    <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-ruler-line text-pink-500"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Tamaño</p>
                      <p className="font-semibold">{selectedItem.size}</p>
                    </div>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-time-line text-pink-500"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Duración</p>
                      <p className="font-semibold">{selectedItem.duration}</p>
                    </div>
                  </div>

                  <div className="flex items-center text-gray-700">
                    <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center mr-4">
                      <i className="ri-map-pin-line text-pink-500"></i>
                    </div>
                    <div>
                      <p className="text-sm text-gray-500">Ubicación</p>
                      <p className="font-semibold">{selectedItem.location}</p>
                    </div>
                  </div>
                </div>

                <div className="space-y-3">
                  <button 
                    onClick={() => {
                      setSelectedItem(null);
                      window.open('https://wa.me/56912345678?text=Hola! Me interesa reservar una cita para un tatuaje similar a "' + selectedItem.title + '" por ' + selectedItem.artist + '. ¿Podrían darme más información?', '_blank');
                    }}
                    className="w-full bg-pink-500 text-white py-4 rounded-lg font-semibold hover:bg-pink-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>
                    Reservar por WhatsApp
                  </button>
                  
                  <button 
                    onClick={() => setSelectedItem(null)}
                    className="w-full bg-gray-100 text-gray-700 py-4 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Cerrar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
